export default function getWindow() {
  return globalThis.window;
}
